module.exports = __webpack_public_path__ + "static/media/nick_garcia.3e330e32.jpg";